import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import {
  Subtitle,
  HeaderContainer,
  Products,
  Price,
  Label,
  Quantity,
  Name,
  Column,
  Product,
  ProductImg,
  LoaderContainer,
  Chevron,
} from './OrderDetailsPage.styles.js';

import MainContainer from '../../components/utils/MainContainer/MainContainer.js';
import MiniLoader from '../../components/MiniLoader/MiniLoader.js';

import openToast from '../../utils/toast.js';
import { priceFormatter } from '../../utils/utils.js';

import { selectOrder, selectSetOrderStatePending } from '../../store/slices/order/slice.js';
import { fetchOrder } from '../../store/slices/order/asyncThunks.js';

const OrderDetailsPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const toastId = useRef(null);
  const { id } = useParams();
  const navigate = useNavigate();

  const { data, loading } = useSelector(selectOrder);
  const setOrderStatePending = useSelector(selectSetOrderStatePending);

  useEffect(() => {
    dispatch(fetchOrder(id))
      .unwrap()
      .then(() => {})
      .catch(err => openToast(toastId, 'error-get', 'error', err.message));
  }, [dispatch, id]);

  return (
    <MainContainer pageTitle={'order-details-title'}>
      {loading || setOrderStatePending ? (
        <LoaderContainer>
          <MiniLoader />
        </LoaderContainer>
      ) : (
        <>
          <HeaderContainer>
            <Chevron
              onClick={() => {
                navigate(-1);
              }}
            />
            <Subtitle>
              {t('order')}
              {`#${data.id}`}
            </Subtitle>
          </HeaderContainer>
          <Products>
            {data?.items?.map((product, i) => (
              <Product key={i}>
                <ProductImg src={product?.photos[0]?.url} />
                <Column>
                  <Label>{t('product-details')}</Label>
                  <Name>{product?.name}</Name>
                  <Price>{priceFormatter(product?.price)} SR</Price>
                </Column>
                <Column>
                  <Label>{t('quantity')}</Label>
                  <Quantity>{product?.quantity}</Quantity>
                </Column>
                <Column>
                  <Label>{t('total')}</Label>
                  <Price>{priceFormatter(product?.totalPrice)} SR</Price>
                </Column>
              </Product>
            ))}
          </Products>
        </>
      )}
    </MainContainer>
  );
};

export default OrderDetailsPage;
